import { CurrencyType } from 'src/types/currency';

export const MAX_LIMIT_ALSHAYA: Partial<Record<CurrencyType, number>> = {
  [CurrencyType.AED]: 15000,
  [CurrencyType.SAR]: 8000,
};
